// extracted by mini-css-extract-plugin
export var orderSearchResultCard = "_c-0";
export var skeletonCard = "_c-1";